<template>
  <div>
    <div style="margin: 0px;position: relative; border-bottom: 1px solid #9d9d9d;">
      <div class="webviewer-header" style="position: relative;"></div>
      <img class="clinic_log_iamge" src="../../../static/images/user_normal.png" height="40">
      <img class="viewer_logo_image" src="../../../static/images/global-logo-red.png" height="60">
    </div>
    <div class="patientInfoPanel">
      <p class="patient-name-label">患者姓名:{{orderDetail.demPatient}}</p>
      <p class="patient-name-label">更新日期:{{orderDetail.updateTime}}</p>
    </div>
    <div id="container">
    </div>
    <div class="fixed-bottom">
      <div class="text-center">
          <ul>
            <li style="padding-right: 8px;">
              <input @change="enableMeshButtons" type="checkbox" v-model="checkedLower" id="cb-lower" />
              <label class="catalog-button-label" for="cb-lower">
                <img src="../../../static/images/lower_normal.svg" />
              </label>
            </li>
            <li style="padding-right: 8px;">
              <input @change="enableMeshButtons" type="checkbox" v-model="checkedUpper" id="cb-upper" />
              <label class="catalog-button-label" for="cb-upper">
                <img src="../../../static/images/upper_normal.svg" />
              </label>
            </li>
            <!-- <li>
              <div @click="ResetRotation" style="display: flex; font-size: 28px; color: black; border: 2px solid #0f0f0f; padding: 4px; background-color: #e0e0e0; border-radius: 5px;">
                <img src="../../../static/images/refresh.svg" />
                <label>切换上下颚</label>
              </div>
            </li> -->
          </ul>
      </div>
    </div>
 <!--  <div class="fixed-right-top">
      <div class="text-center">
          <ul>
            <li>
              <div @click="initUrl" style="display: flex; font-size: 28px; color: black; border: 2px solid #0f0f0f; padding: 4px; background-color: #e0e0e0; border-radius: 5px;">
                <img src="../../../static/images/refresh.svg" />
                <label>切换上下颚</label>
              </div>
            </li>
          </ul>
      </div>
    </div> -->

  </div>
</template>

<script>
  import * as THREE from 'three'
  // 引入控制器
  import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
  // import { TrackballControls } from 'three/examples/jsm/controls/TrackballControls.js'

  // 引入stl加载器
  import { STLLoader } from 'three/examples/jsm/loaders/STLLoader.js'
  import { PLYLoader } from 'three/examples/jsm/loaders/PLYLoader.js'
  import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js'

  export default {
    data() {
      return {
        checkedLower: false,
        checkedUpper: false,
        g_isImplantCase: false,
        g_upperMeshGot: false,
        g_lowerMeshGot: false,
        g_scanbodyUpperMeshGot: false,
        g_scanbodyLowerMeshGot: false,
        g_allMeshDownloaded: true,

        g_renderer:null,
        g_scene:null,
        g_camera:null,
        g_lowerMesh: null,
        g_lowerBackMesh: null,
        g_upperMesh: null,
        g_upperBackMesh: null,
        raycaster:null,
        g_lowerMeshCloudUrl: null,
        g_upperMeshCloudUrl: null,
         /* */
        g_isDragging: false,
        g_previousMousePosition: {
           x: 0,
           y: 0
        },
         //参考 https://cloud.tencent.com/developer/article/1444204  鼠标控制物体旋转
        g_targetRotation: 0,
        g_targetRotationOnMouseDown: 0,
        g_mouseX: 0,
        g_mouseXOnMouseDown: 0,

        g_windowHalfX: window.innerWidth / 2,
        g_windowHalfY: window.innerHeight / 2,
        g_frustumSize: 100,
        g_orbitControls: null,
        g_trackballControls: null,
        g_container: null,
        orderDetail: '',
        isJson: false,
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.g_container = document.getElementById('container');
        this.loadData();
      },
      async loadData() {
        this.$api.get({
          url: '/biz/orderServ/detail/' + this.$route.query.orderId
        }).then(res => {
          console.log('res:',res)
          let detailData = {};
          for (var key in res.data) {
            if (key === "posSingle" || key === "posBridge") {
              detailData.posSingleList = res.data.posSingle.split(',');
            } else if (key === "posBridgeList") {
              detailData.posBridgeList = res.data.posBridge.split(',');
            } else {
              detailData[key] = res.data[key];
            }
          }
          try{
            detailData.designData = JSON.parse(res.data.designData);
            this.isJson = true
          }catch(e){
            detailData.designData = res.data.designData.split(',')
            this.isJson = false
          }
          this.orderDetail = detailData;
          this.initUrl();
          // this.orderDetail.servName = this.common.serv.get(this.orderDetail.servCataId).servName;

        })
      },
      updateLoadingProcess(jaw_type) {
        if (jaw_type == 'lower') {
          this.g_lowerMeshGot = true;
        }
        if (jaw_type == 'upper') {
          this.g_upperMeshGot = true;
        }
        if (jaw_type == 'scanbodyLower') {
          this.g_scanbodyLowerMeshGot = true;
        }
        if (jaw_type == 'scanbodyUpper') {
          this.g_scanbodyUpperMeshGot = true;
        }

        let all_download_percent = 0;
        if (this.g_isImplantCase) {
          all_download_percent = ((this.g_lowerMeshGot ? 100 : 0) + (this.g_upperMeshGot ? 100 : 0) + (this.g_scanbodyLowerMeshGot ?
            100 : 0) + (this.g_scanbodyUpperMeshGot ? 100 : 0)) / 4;
        } else {
          all_download_percent = ((this.g_lowerMeshGot ? 100 : 0) + (this.g_upperMeshGot ? 100 : 0)) / 2;
        }
        this.updateLoadingProgress(all_download_percent);
      },
      initUrl() {
        this.g_isImplantCase = false
        if(this.isJson){
          this.g_lowerMeshCloudUrl = this.orderDetail.designData[0].url
          this.g_upperMeshCloudUrl = this.orderDetail.designData[1].url
        }else{
          this.g_lowerMeshCloudUrl = this.orderDetail.designData[0]//"./static/stl/orthodontics_俞驰_20220722_094216_lower.ply"
          this.g_upperMeshCloudUrl = this.orderDetail.designData[1]//"./static/stl/orthodontics_俞驰_20220722_094216_upper.ply"
        }
        this.checkedLower = true
        this.checkedUpper = true
        this.enableMeshButtons()
        this.init3dScene();
      },
      LoadMesh(input_jawer_type, url) {
        let that = this
        if (url == null) {
          return;
        }
        let jawer_type = input_jawer_type;
        let manager = new THREE.LoadingManager();
        manager["jawer_type"] = input_jawer_type;
        manager.onStart = function(item, loaded, total) {
        };
        manager.onLoad = function() {
          // that.updateLoadingProcess(manager["jawer_type"]);
        };
        manager.onError = function(url) {
          // console.log('Error loading');
        };
        let loader = null;
        if (url.endsWith(".ply")) {
          loader = new PLYLoader(manager);
        } else if (url.endsWith(".stl")) {
          loader = new STLLoader(manager);
        } else if (url.endsWith(".obj")) {
          loader = new OBJLoader(manager);
        }
        const textureLoader = new THREE.TextureLoader(manager);
        loader.load(url, function(geometry) {
          if (!url.endsWith(".obj")) {
            geometry.computeVertexNormals();
          }
          const material = new THREE.MeshStandardMaterial({
            color: 0x888888,
            flatShading: true,
            vertexColors: true,
          });
          material.side = THREE.FrontSide;

          const backMaterial = new THREE.MeshStandardMaterial({
            color: 0x393939,
            flatShading: false,
            vertexColors: false
          });
          backMaterial.side = THREE.BackSide;

          const stlMaterial = new THREE.MeshStandardMaterial({
            color: 0x43404C,
            flatShading: false,
            vertexColors: false
          });
          stlMaterial.side = THREE.FrontSide;

          let frontMaterial = material;
          if (url.endsWith(".stl")) {
            frontMaterial = stlMaterial;
            if(geometry.hasColors || geometry.attributes.color) {
            	frontMaterial = new THREE.MeshStandardMaterial( {flatShading: true, vertexColors: true } );
            }
          }
          let tempMesh = null;
          let tempBackMesh = null;
          if (url.endsWith(".obj")) {
            {
              var texture_jpg = url.replace(".obj", ".jpg");
              if (ImageExist(texture_jpg)) {
                var texture = new THREE.TextureLoader().load(texture_jpg);
                // immediately use the texture for material creation
                var texture_material = new THREE.MeshBasicMaterial({
                  map: texture
                });
                geometry.children[0].material = texture_material;
              } else {
                geometry.children[0].material = stlMaterial;
              }
            }
            tempMesh = geometry.children[0];
            tempBackMesh = geometry.children[0].clone();
            tempBackMesh.material = backMaterial;
          } else {
            let monoMaterial = frontMaterial;
            tempMesh = new THREE.Mesh(geometry, monoMaterial);
            tempMesh.position.x = 0;
            tempMesh.position.y = 0;
            tempMesh.position.z = 0;
            tempBackMesh = new THREE.Mesh(geometry, backMaterial);
            tempBackMesh.rotation.copy(tempMesh.rotation);
          }
          if (input_jawer_type == 'lower') {
            that.g_lowerMesh = tempMesh;
            that.g_lowerBackMesh = tempBackMesh;
            that.g_scene.add(that.g_lowerMesh);
            that.g_scene.add(that.g_lowerBackMesh);
          }
          if (input_jawer_type == 'upper') {
            that.g_upperMesh = tempMesh;
            that.g_upperBackMesh = tempBackMesh;
            that.g_scene.add(that.g_upperMesh);
            that.g_scene.add(that.g_upperBackMesh);
          }
        });
      },
      init3dScene() {
        this.g_renderer = new THREE.WebGLRenderer({
          antialias: true //抗锯齿
        });
        //改色差
        this.g_renderer.outputEncoding = THREE.sRGBEncoding;

        this.g_renderer.setPixelRatio(window.devicePixelRatio);
        this.g_renderer.setSize(window.innerWidth, window.innerHeight);
        this.g_container.appendChild(this.g_renderer.domElement);
        this.g_scene = new THREE.Scene();
        var aspect = window.innerHeight / window.innerWidth;
        this.g_camera = new THREE.OrthographicCamera(this.g_frustumSize / -2, this.g_frustumSize / 2, this.g_frustumSize * aspect / 2,
        this.g_frustumSize * aspect / -2, -500, 500);
        this.g_camera.position.z = 120;
        //创建控件对象  相机对象camera作为参数   控件可以监听鼠标的变化，改变相机对象的属性
        this.g_orbitControls = new OrbitControls(this.g_camera, this.g_renderer.domElement);
        this.g_orbitControls.enableRotate = false;

        // this.g_trackballControls = new TrackballControls( this.g_camera, this.g_renderer.domElement );
        // this.g_trackballControls.minDistance = 200;
        // this.g_trackballControls.maxDistance = 500;
        // this.g_trackballControls.rotateSpeed = 5.0;
        // this.g_trackballControls.panSpeed = 10.0;
        // this.g_trackballControls.staticMoving = true;


        // https://blog.csdn.net/disasters/article/details/81872885 灯光参考
        this.g_scene.add(new THREE.AmbientLight(0xffffff));
        let light = new THREE.DirectionalLight();
        light.position.set(1, 1, 100);
        this.g_scene.add(light);

        const geometry = new THREE.BufferGeometry();
        geometry.setFromPoints([new THREE.Vector3(), new THREE.Vector3()]);
        this.loadMeshes();
        this.g_scene.background = new THREE.Color(0xffffff);
        this.raycaster = new THREE.Raycaster();
        window.addEventListener('resize', this.onWindowResize);

        // mouse actions
        document.addEventListener("pointerdown", this.onDocumentMouseDown, false);
        document.addEventListener("pointerup", this.onDocumentMouseUp, false);
        document.addEventListener("pointermove", this.onDocumentMouseMove, false);
        // document.addEventListener("touchstart", this.onDocumentTouchStart, false);
        // document.addEventListener("touchmove", this.onDocumentTouchMove, false);
        document.addEventListener("touchend", this.onDocumentTouchEnd, false);
        this.onWindowResize();
        this.render();
      },
      updateLoadingProgress(all_download_percent) {
        document.getElementById('nei_all').style.width = all_download_percent + '%';
      },
      loadMeshes() {
        this.LoadMesh('lower', this.g_lowerMeshCloudUrl);
        this.LoadMesh('upper', this.g_upperMeshCloudUrl);
      },
      enableMeshButtons() {
        this.$nextTick(()=>{
          if (this.g_lowerMesh != null) {
            this.g_lowerMesh.visible = this.checkedLower;
            this.g_lowerBackMesh.visible = this.checkedLower;
          }
          if (this.g_upperMesh) {
            this.g_upperMesh.visible = this.checkedUpper;
            this.g_upperBackMesh.visible = this.checkedUpper;
          }
        })
      },
      onDocumentMouseDown(event) {
        if (!this.g_allMeshDownloaded) {
          return;
        }
        event.preventDefault();
        this.g_isDragging = true;
        this.g_previousMousePosition = {
          x: event.offsetX,
          y: event.offsetY
        };
      },

      onDocumentMouseMove(event) {
        if (!this.g_allMeshDownloaded) {
          return;
        }
        this.onPointerMove(event)
      },
      onDocumentMouseUp(event) {
        if (!this.g_allMeshDownloaded) {
          return;
        }
        this.g_isDragging = false;
      },
      onDocumentTouchStart(event) {
        if (!this.g_allMeshDownloaded) {
          return;
        }
        if (event.touches.length === 1) {
          this.g_mouseXOnMouseDown = event.touches[0].layerX - this.g_windowHalfX;
        }
      },

      onDocumentTouchEnd(event) {
        this.g_isDragging = false;
      },
      onDocumentTouchMove(event) {
        if (!this.g_allMeshDownloaded) {
          return;
        }
        if (event.touches.length === 1) {
          mouseX = event.touches[0].layerX - this.g_windowHalfX;
          this.g_targetRotation = this.g_targetRotationOnMouseDown + (mouseX - this.g_mouseXOnMouseDown) * 0.05;;
        }
      },
      onPointerMove(event) {
        if (!this.g_allMeshDownloaded) {
          return;
        }
        if (event.isPrimary) {
          let deltaMove = {
            x: event.offsetX - this.g_previousMousePosition.x,
            y: event.offsetY - this.g_previousMousePosition.y
          };

          if (this.g_isDragging) {
            let delta_x = deltaMove.x;
            let delta_y = deltaMove.y;

            if (event.buttons === 1) // left button
            {
              let deltaRotationQuaternion = new THREE.Quaternion()
                .setFromEuler(new THREE.Euler(
                  this.toRadians(deltaMove.y * 1 * 0.3),
                  this.toRadians(deltaMove.x * 1 * 0.3),
                  0,
                  'XYZ'
                ));

              if (this.g_lowerMesh != null) {
                this.g_lowerMesh.quaternion.multiplyQuaternions(deltaRotationQuaternion, this.g_lowerMesh.quaternion);
                this.g_lowerBackMesh.quaternion.multiplyQuaternions(deltaRotationQuaternion, this.g_lowerBackMesh.quaternion);
              }
              if (this.g_upperMesh != null) {
                this.g_upperMesh.quaternion.multiplyQuaternions(deltaRotationQuaternion, this.g_upperMesh.quaternion);
                this.g_upperBackMesh.quaternion.multiplyQuaternions(deltaRotationQuaternion, this.g_upperBackMesh.quaternion);
              }
              if (this.g_scanbodyLowerMesh != null) {
                this.g_scanbodyLowerMesh.quaternion.multiplyQuaternions(deltaRotationQuaternion, this.g_scanbodyLowerMesh
                  .quaternion);
                this.g_scanbodyLowerBackMesh.quaternion.multiplyQuaternions(deltaRotationQuaternion, this.g_scanbodyLowerBackMesh
                  .quaternion);
              }
            } else if (event.buttons === 2) {
            }
          }

          this.g_previousMousePosition = {
            x: event.offsetX,
            y: event.offsetY
          };
        }
      },
      ResetCamera() {
          this.g_camera.position.set(0, 0, 120);
          this.g_trackballControls.reset();
          this.g_trackballControls.target.set(0, 0, 0);
          this.g_trackballControls.update();
      },
      ResetRotation() {
        let deltaRotationQuaternion = new THREE.Quaternion()
          .setFromEuler(new THREE.Euler(
            this.toRadians(0 * 1 * 0.3),
            this.toRadians(0 * 1 * 0.3),
            0,
            'XYZ'
          ));
        if (this.g_lowerMesh != null) {
          this.g_lowerMesh.quaternion.multiplyQuaternions(deltaRotationQuaternion, this.g_lowerMesh.quaternion);
          this.g_lowerBackMesh.quaternion.multiplyQuaternions(deltaRotationQuaternion, this.g_lowerBackMesh.quaternion);
        }
        if (this.g_upperMesh != null) {
          this.g_upperMesh.quaternion.multiplyQuaternions(deltaRotationQuaternion, this.g_upperMesh.quaternion);
          this.g_upperBackMesh.quaternion.multiplyQuaternions(deltaRotationQuaternion, this.g_upperBackMesh.quaternion);
        }
      },
      toRadians(angle) {
        return angle * (Math.PI / 180);
      },
      toDegrees(angle) {
        return angle * (180 / Math.PI);
      },
      onWindowResize() {
        var aspect = window.innerHeight / window.innerWidth;
        this.g_camera.left =this.g_frustumSize / -2;
        this.g_camera.right = this.g_frustumSize / 2;
        this.g_camera.top = this.g_frustumSize * aspect / 2;
        this.g_camera.bottom = -this.g_frustumSize * aspect / 2;

        this.g_camera.updateProjectionMatrix();
        this.g_renderer.setSize(window.innerWidth, window.innerHeight);
      },

      // 渲染函数
      render() {
        requestAnimationFrame(this.render); //下一帧执行代码
           // var vector = this.g_camera.position.clone();
           //  this.g_pointLight.position.set(vector.x, vector.y, vector.z);
           //  this.g_direction_light.position.set(vector.x, vector.y, vector.z);
           //  this.g_trackballControls.update();
        this.g_renderer.render(this.g_scene, this.g_camera); //执行渲染操作
      }
    }
  }
</script>

<style scoped>
  ::-webkit-scrollbar {
     width: 0 !important;
   }
   ::-webkit-scrollbar {
     width: 0 !important;height: 0;
   }
  .webviewer-header {
    height: 80px;
    padding: 10px 10px 0 20px;
    margin-top: 20px;
    display: block;
    background-color: #fff;
  }
  .viewer_logo_image {
    position: absolute;
    right: 20px;
    top: 20px;
  }
  .clinic_log_iamge {
    height: 40px;
    position: absolute;
    left: 20px;
    top: 20px;
  }
  .patientInfoPanel {
    position: fixed;
    width: 100%;
    top: 100px;
    padding-left: 20px;
    background-color: rgba(0,0,0,0);
    pointer-events: none;
  }
  .patient-name-label {
    font-size: 16px;
    font-weight: 300;
    line-height: 1.5;
    color: #212529;
  }
  .fixed-right-top {
    position: fixed;
    right: 120px;
    top: 140px;
    /* left: 20px; */
    z-index: 1030;
  }
  .fixed-bottom {
    position: fixed;
    right: 0;
    bottom: 20px;
    left: 0;
    z-index: 1030;
  }
  .text-center {
    text-align: center!important;
  }
  li {
    display: inline-block;
  }
  input[type="checkbox"][id^="cb"] {
    display: none;
  }
  input[type="checkbox"][id^="cb"]:disabled+label {
    opacity: 0.3;
  }
  label.catalog-button-label {
    border-radius: 4px;
    display: block;
    background-color: #ffffff;
    position: relative;
    margin: 0px;
    cursor: pointer;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    filter: drop-shadow(0px 2px 2px rgba(51, 51, 51, 0.25));
  }
  label img {
    height: 50px;
    width: 50px;
    transform-origin: 50% 50%;
  }
  :checked+label {
     background-color: #1E8EFD;
  }
</style>



// WEBPACK FOOTER //
// 3Dmodel.vue?62eda53e